const STORAGE_KEY = "sendcollab:returnTo";

function isSafePath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//");
}

function isAuthPath(path: string): boolean {
  return /^\/(login|signup|onboarding)(\/|\?|$)/.test(path);
}

/** Remember where to send the user after sign-in / sign-up. */
export function setReturnTo(path: string): void {
  if (typeof window === "undefined") return;
  if (!isSafePath(path) || isAuthPath(path)) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, path);
  } catch {
    /* private mode / quota */
  }
}

export function peekReturnTo(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    if (!value || !isSafePath(value) || isAuthPath(value)) return null;
    return value;
  } catch {
    return null;
  }
}

export function clearReturnTo(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Prefer an explicit `?next=` path; otherwise the stored creator-page return. */
export function resolveAuthNext(explicit?: string | null): string | undefined {
  if (explicit && isSafePath(explicit) && !isAuthPath(explicit)) return explicit;
  return peekReturnTo() ?? undefined;
}
